import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getUnfinishedReportsShiftSummary(context, userId) {
        return axios
            .get(`/reports/reports-shift-summaries?user_id=${userId}&status_id=1`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie raportów zbiorczych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDetailedUserReports({ commit }, {
        reportShiftSummaryId = null,
        paginate = '',
        query = ''
    }) {
        commit('GET_DETAILED_USER_REPORTS_REQUEST')

        return axios
            .get(`/reports/reports${paginate}${reportShiftSummaryId}${query}`)
            .then(response => {
                commit('GET_DETAILED_USER_REPORTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_DETAILED_USER_REPORTS_FAILURE')
                handleApiError(error, 'Pobranie raportów szczegółowych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReportProcesses(context, productionSite_id) {
        return axios
            .get(`/reports/reports/dicts/report-process-codes?productionSite_id=${productionSite_id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie procesów do zaraportowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    startReportingSession({ commit }) {
        return axios
            .post('/reports/reports-shift-summaries')
            .then(response => {
                commit('START_REPORTING_SESSION')

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Rozpoczęcie sesji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    stopReportingSession({ commit }, { id, statusId }) {
        return axios
            .put(`/reports/reports-shift-summaries/${id}`, {
                statusId
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zakończono pracę.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zakończenie sesji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReport(context, reportId) {
        return axios
            .get(`/reports/reports/${reportId}`)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych do raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createReport({ commit }, payload) {
        return axios
            .post('/reports/reports', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rozpoczęto rejestrowanie czasu.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Rejestrowanie czasu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    addPallet({ commit }, payload) {
        return axios
            .post('/reports/report-pallets', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dodano paletę z papierem do raportu.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie palety z papierem nie powiodło się.')

                return Promise.reject(error)
            })
    },
    removePallet({ commit }, id) {
        return axios
            .delete(`/reports/report-pallets/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Paleta z papierem została usunięta z raportu.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie palety z papierem nie powiodło się.')

                return Promise.reject(error)
            })
    },
    finishReport({ commit }, {id, payload}) {
        return axios
            .put(`/reports/reports/${id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zakończono rejestrowanie czasu.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zakończenie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    renewReport({ commit }, {id, payload}) {
        return axios
            .put(`/reports/reports/${id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wznowiono rejestrowanie czasu.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wznowienie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateReport({ commit }, {id, payload}) {
        return axios
            .put(`/reports/reports/${id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zedytowano raport.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja raportu nie powiodła się.')

                return Promise.reject(error)
            })
    },
    endMakeReady({ commit }, {id, payload}) {
        return axios
            .put(`/reports/reports/${id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zakończono raportowanie przyrządu. Rozpoczęto jazdę.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zakończenie raportowania przyrządu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getScheduledTasks(context, payload) {
        const { machineCode, limit } = payload
        let queryParams = '?'

        if (machineCode) {
            queryParams += `machCode=${machineCode}`
        }
        if (limit) {
            queryParams += `&limit=${limit}`
        }

        return axios
            .get(`/reports/reports/scheduled-tasks${queryParams}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie zaplanowanych zadań nie powiodło się.')

                return Promise.reject(error)
            })
    },
    findTask(context, {taskNumber, typeId = '', elastic}) {
        let elasticQueryParam = ''
        
        if (elastic) {
            elasticQueryParam = '&elastic=true'
        }

        return axios
            .get(`/reports/report-items?primaryNumber=${taskNumber}&typeId=${typeId}${elasticQueryParam}&limit=100`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Szukanie zadań nie powiodło się.')

                return Promise.reject(error)
            })

    },
    getTask(context, {taskId, processId}) {
        return axios
            .get(`/reports/report-items/${taskId}?productionProcess_id=${processId}`)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych do zlecenia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getNextPlatesToReport(context, {taskNumber, processId, typeId}) {
        return axios
            .get(`/reports/report-items-next-unreported-plates/${taskNumber}/${processId}/${typeId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych o kolejnych niezaraportowanych montażach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReportItemOrders(context, {
        productionSiteId = null,
        query = ''
    }) {
        return axios
            .get(`/reports/report-item-orders/${productionSiteId}${query}`)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReportItemOrderJobs(context, {
        query = ''
    }) {

        return axios
            .get(`/reports/report-item-order-jobs${query}`)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych o zleceniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setReportSettings({ commit }, data) {
        commit('SET_REPORT_SETTINGS', data)
    },
    clearReportSettings({ commit }) {
        commit('CLEAR_REPORT_SETTINGS')
    },
    setMachineProcesses({ commit }, data) {
        commit('SET_MACHINE_PROCESSES', data)
    },
    setReportItemOrdersFilters({ commit }, filters) {
        commit('SET_REPORT_ITEM_ORDERS_FILTERS', filters)
    },
    clearReportItemOrdersFilters({ commit }) {
        commit('CLEAR_REPORT_ITEM_ORDERS_FILTERS')
    },
    createAccident({ commit }, accidentData) {
        return axios
            .post('/accidents/accidents', accidentData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Awaria została przypisana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Przypisanie awarii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getUnsolvedMachineAccidents(context, machineId) {
        return axios
            .get(`accidents/accidents-review?isSolved=false&machine=${machineId}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy bieżących awarii dla aktualnego stanowiska nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReportOutOfSequenceCodes({ commit }) {
        return axios
            .get('reports/reports/dicts/report-out-of-sequence-codes')
            .then(response => {
                commit('GET_REPORT_OUT_OF_SEQUENCE_CODES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie kodów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCommentCodes(context, codeTypeId) {
        return axios
            .get(`reports/reports/dicts/report-comment-codes?codeType_id=${codeTypeId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie kodów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getAdditionalActionProcessProductionSite(context, {
        processId = null,
        productionSiteId = null,
        query = ''
    }) {
        return axios
            .get(`reports/reports/dicts/additional-action-process-production-site/${processId}/${productionSiteId}${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie dodatkowych czynności nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getAdditionalActionReportProcessCodeProductionSite(context, {
        processCodeId = null,
        productionSiteId = null,
        query = ''
    }) {
        return axios
            .get(`reports/reports/dicts/additional-action-report-process-code-production-site/${processCodeId}/${productionSiteId}${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie dodatkowych czynności nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShippingGroups({commit}) {
        return axios
            .get('reports/reports/dicts/shipping-groups')
            .then(response => {
                commit('GET_SHIPPING_GROUPS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych o sortowniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPlateOrderReasons({commit}) {
        return axios
            .get('plate-orders/dicts/plate-order-reasons')
            .then(response => {
                commit('GET_PLATE_ORDER_REASONS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie powodów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReportItemColours(_, id) {
        return axios
            .get(`reports/report-item-colours/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie kolorów raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createPlatesOrder({ commit }, payload) {
        return axios
            .post('/plate-orders/plate-orders', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zamówienie płyt zostało utworzone.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Zamówienie płyt nie powiodło się.')

                return Promise.reject(error)
            })
    }
}
